
function CommonInputPhoneNumber({inputValue, setInputValue, placeholder, isValid}) {

  const handleClear = () => {
    setInputValue('');
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        className={`
          border-[1px] w-full h-[54px] rounded-lg px-4 mt-2 placeholder-[#AEB0B6]
          border-[#D0D5DD] 
          ${!isValid && 'outline-[#E95C4F] border-[#E95C4F] border-[2px]'}
          `}
        placeholder={placeholder}
      />
    </div>
  );
}

export default CommonInputPhoneNumber;